import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { GenericIconRenderer } from './content-icon-renderer';
import { messages } from '../../messages';
import { getTeamPath, getUserPath } from '@atlassian/search-common';
export var getQuickFindPeopleAndTeamsResultMapper = function getQuickFindPeopleAndTeamsResultMapper(primaryProduct, orgId, cloudId) {
  return function (result) {
    if (result.type === 'team') {
      return {
        title: result.name,
        id: result.id,
        type: result.type,
        meta: /*#__PURE__*/React.createElement(FormattedMessage, messages.quick_find_results_team),
        url: "".concat(window.location.origin).concat(getTeamPath(result.id, primaryProduct, orgId, cloudId)),
        icon: GenericIconRenderer({
          iconUrl: result.avatarUrl
        })
      };
    } else {
      return {
        title: result.name,
        id: result.id,
        type: result.type,
        meta: result.title || '',
        url: "".concat(window.location.origin).concat(getUserPath(result.id, primaryProduct, orgId, cloudId)),
        icon: GenericIconRenderer({
          iconUrl: result.avatarUrl,
          appearance: 'circle'
        })
      };
    }
  };
};